import { useRef } from 'react';

import useGsapSection from '../../hooks/useGsapSection';

import { ScrambleReveal } from '../TextEffects';



const CaseStudyTech = ({ items }) => {

  const ref = useRef(null);

  const inView = useGsapSection(ref);



  if (!items?.length) return null;



  return (

    <section className="cs-tech" ref={ref} data-testid="case-study-tech">

      <div className="cs-tech-inner gsap-reveal">

        {items.map((item, i) => (

          <span key={item} style={{ display: 'contents' }}>

            {i > 0 && <span className="cs-tech-sep" aria-hidden="true">✦</span>}

            <ScrambleReveal

              text={item}

              className="cs-tech-item"

              delay={0.04 + i * 0.04}

              externalInView={inView}

            />

          </span>

        ))}

      </div>

    </section>

  );

};



export default CaseStudyTech;

